module.exports = __webpack_public_path__ + "static/media/areas.a05705fb.png";